import React from 'react';
import PropTypes from 'prop-types';
import { sendToGA } from '@react-shared/helpers/send-to-ga';
import styles from './external-link.module.scss';

const ExternalLink = ({ item, active }) => (
  <a
    href={item.url}
    className={`${active ? styles.currentPage : ''}`}
    onClick={() => sendToGA({
      event: 'Menu',
      action: 'MenuLinkSelect',
      type: 'external-link'
    })}
  >
    {item.linkTitle}
  </a>
);

ExternalLink.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  item: PropTypes.any.isRequired,
  active: PropTypes.bool.isRequired
};

export default ExternalLink;
